var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.75 9.5L12.75 15.5L18.75 9.5","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }